export const REGIONAL_FILIAL_GET_REQUEST = 'REGIONAL_FILIAL_GET_REQUEST';
export const REGIONAL_FILIAL_GET_SUCCESS = 'REGIONAL_FILIAL_GET_SUCCESS';
export const REGIONAL_FILIAL_GET_ERROR = 'REGIONAL_FILIAL_GET_ERROR';
export const REGIONAL_FILIAL_GET_BY_KEY_REQUEST = 'REGIONAL_FILIAL_GET_BY_KEY_REQUEST';
export const REGIONAL_FILIAL_GET_BY_KEY_SUCCESS = 'REGIONAL_FILIAL_GET_BY_KEY_SUCCESS';
export const REGIONAL_FILIAL_GET_BY_KEY_ERROR = 'REGIONAL_FILIAL_GET_BY_KEY_ERROR';
export const REGIONAL_FILIAL_ADD_REQUEST = 'REGIONAL_FILIAL_ADD_REQUEST';
export const REGIONAL_FILIAL_ADD_SUCCESS = 'REGIONAL_FILIAL_ADD_SUCCESS';
export const REGIONAL_FILIAL_ADD_ERROR = 'REGIONAL_FILIAL_ADD_ERROR';
export const REGIONAL_FILIAL_EDIT_REQUEST = 'REGIONAL_FILIAL_EDIT_REQUEST';
export const REGIONAL_FILIAL_EDIT_SUCCESS = 'REGIONAL_FILIAL_EDIT_SUCCESS';
export const REGIONAL_FILIAL_EDIT_ERROR = 'REGIONAL_FILIAL_EDIT_ERROR';
export const REGIONAL_FILIAL_DELETE_REQUEST = 'REGIONAL_FILIAL_DELETE_REQUEST';
export const REGIONAL_FILIAL_DELETE_SUCCESS = 'REGIONAL_FILIAL_DELETE_SUCCESS';
export const REGIONAL_FILIAL_DELETE_ERROR = 'REGIONAL_FILIAL_DELETE_ERROR';
